export const HOME = '/'
export const LOGIN = '/login'
export const SETTINGS = '/settings'

const USERS = '/users'
const NEW_USER = `${USERS}/new`
const UPDATE_USER = `${USERS}/:id`

const BEACONS = '/beacons'
const NEW_BEACON = `${BEACONS}/new`
const UPDATE_BEACON = `${BEACONS}/:id`

const MANUFACTURERS = '/manufacturers'
const NEW_MANUFACTURER = `${MANUFACTURERS}/new`
const UPDATE_MANUFACTURER = `${MANUFACTURERS}/:id`

const MODELS = '/models'
const NEW_MODEL = `${MODELS}/new`
const UPDATE_MODEL = `${MODELS}/:id`

const TEMPLATES = '/templates'
const NEW_TEMPLATE = `${TEMPLATES}/new`
const UPDATE_TEMPLATE = `${TEMPLATES}/:id`

const PAGES = '/pages'
const NEW_PAGE = `${PAGES}/new`
const UPDATE_PAGE = `${PAGES}/:id`

const goToUser = id => `${USERS}/${id}`
const goToBeacon = id => `${BEACONS}/${id}`
const goToManufacturer = id => `${MANUFACTURERS}/${id}`
const goToModel = id => `${MODELS}/${id}`
const goToTemplate = id => `${TEMPLATES}/${id}`
const goToPage = id => `${PAGES}/${id}`

export default {
  goToUser,
  goToBeacon,
  goToManufacturer,
  goToModel,
  goToTemplate,
  goToPage,

  HOME,
  LOGIN,
  SETTINGS,

  USERS,
  NEW_USER,
  UPDATE_USER,

  BEACONS,
  NEW_BEACON,
  UPDATE_BEACON,

  MANUFACTURERS,
  NEW_MANUFACTURER,
  UPDATE_MANUFACTURER,

  MODELS,
  NEW_MODEL,
  UPDATE_MODEL,

  TEMPLATES,
  NEW_TEMPLATE,
  UPDATE_TEMPLATE,

  PAGES,
  NEW_PAGE,
  UPDATE_PAGE
}


// WEBPACK FOOTER //
// ./src/constants/routes.js